import React from 'react';

import { PageTitle } from '@cordata/buffet';

import FacilitiesForm from '~/components/Facility/Form';

const FacilitiesAdd = () => (
  <>
    <PageTitle>Add Facility</PageTitle>

    <FacilitiesForm />
  </>
);

export default FacilitiesAdd;
